import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { NoticeboardButton } from "../../shared";

export interface FeeStatementPrimaryAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

export interface FeeStatementMenuAction {
  key: string;
  label: string;
  icon?: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  destructive?: boolean;
}

interface FeeStatementActionBarProps {
  primaryActions: FeeStatementPrimaryAction[];
  menuActions: FeeStatementMenuAction[];
}

export const FeeStatementActionBar: React.FC<FeeStatementActionBarProps> = ({
  primaryActions,
  menuActions,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const closeMenu = () => setMenuAnchor(null);

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      flexWrap="wrap"
      sx={{ mt: 1.5 }}
    >
      {primaryActions.map((action) => (
        <NoticeboardButton
          key={action.key}
          variant="secondary"
          size="small"
          startIcon={action.icon}
          disabled={action.disabled}
          onClick={action.onClick}
        >
          {action.label}
        </NoticeboardButton>
      ))}
      {menuActions.length > 0 ? (
        <>
          <IconButton
            size="small"
            aria-label="More actions"
            onClick={(e) => setMenuAnchor(e.currentTarget)}
          >
            <MoreHorizIcon />
          </IconButton>
          <Menu
            anchorEl={menuAnchor}
            open={Boolean(menuAnchor)}
            onClose={closeMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            {menuActions.map((action) => (
              <MenuItem
                key={action.key}
                disabled={action.disabled}
                onClick={() => {
                  closeMenu();
                  action.onClick();
                }}
                sx={action.destructive ? { color: "error.main" } : undefined}
              >
                {action.icon ? (
                  <ListItemIcon
                    sx={{
                      color: action.destructive ? "error.main" : "inherit",
                      minWidth: 36,
                    }}
                  >
                    {action.icon}
                  </ListItemIcon>
                ) : null}
                <ListItemText>{action.label}</ListItemText>
              </MenuItem>
            ))}
          </Menu>
        </>
      ) : null}
    </Stack>
  );
};
